
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/stock/dividend",
      function () {
        return require("private-next-pages/ir/stock/dividend.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/stock/dividend"])
      });
    }
  